import http from "@/settings/apiSettings"

class DOC_DocumenteDataService {
    save(data: any): Promise<any> {
        return http.clientDocumenteOdata.post("/DOC_Documente", data);
    }
    update(id: string, data: any): Promise<any> {
        return http.clientDocumenteOdata.put(`/DOC_Documente/${id}`, data);
    }
    genereazaDocumentDinComanda(dto: any): Promise<any> {
        return http.clientDocumente.post('doc/genereaza-din-comanda', dto);
    }
    genereazaFacturaProiect(dto: any): Promise<any> {
        return http.clientDocumente.post('doc/genereaza-factura-proiect', dto);
    }
}
export default new DOC_DocumenteDataService();
